import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
// react-query
import { queryClient } from "@config/tanstack/tanstackQuery";
import { makeSurveyConfigQueryOpts } from "src/services/surveyHooks/survey-api-queries";
// UI
import { RouterLoadingComponent } from "@components/router-loading-component";
import { RouterGenericError } from "@components/router-generic-error";
import { SurveyFlowPage } from "@pages/survey-flow/survey-flow-page";

const surveyFlowSearchSchema = z.object({
  // NOTE: if invalid/missing, will default to empty object. If not desired behavior,
  // lets not use `fallback` and instead show error UI/alert sentry
  meta: z.string().base64().default(""),
  // number | undefined - if not set, "never expire"
  // `.catch` makes it not show error/alert sentry, which is desired for optional params ofc.
  discardCacheAfterDays: z.number().optional().catch(undefined),
});

export const Route = createFileRoute("/s/$surveyId")({
  // https://tanstack.com/router/v1/docs/framework/react/guide/data-loading#using-loaderdeps-to-access-search-params
  loaderDeps: ({ search: { meta } }) => ({ meta }),

  // NOTE: data is pre-loaded here and has seamless integration with react Suspense.
  // - useSuspenseQuery(...) called in SurveyFlowPage, no need to check `undefined` data or loading
  // - if API request errors out, errorComponent will be shown
  // - while fetch is being meade, pendingComponent will be shown
  loader: async (ctx) => {
    return await queryClient.ensureQueryData(
      makeSurveyConfigQueryOpts(ctx.params.surveyId, ctx.deps.meta),
    );
  },
  component: SurveyFlowPage,
  pendingComponent: RouterLoadingComponent,
  errorComponent: RouterGenericError,
  //
  validateSearch: zodValidator(surveyFlowSearchSchema),
});
